import { Action } from '@ngrx/store';
import { Share } from 'src/app/models/share';

export const ShareAction = {
    addShare: '[share] add share',
    forceShareRefresh: '[share] refresh on next pull',
    removeShare: '[share] remove share',
    setShares: '[share] set shares',
    updateShare: '[share] update share',
};

export class AddShare implements Action {
    type = ShareAction.addShare;
    constructor(public share: Share) {}
}

export class RemoveShare implements Action {
    type = ShareAction.removeShare;
    constructor(public shareId: string) {}
}

export class SetShares implements Action {
    type = ShareAction.setShares;
    constructor(public shares: Share[]) {}
}

export class UpdateShare implements Action {
    type = ShareAction.updateShare;
    constructor(public share: Share) {}
}

export class ForceShareRefresh implements Action {
    type = ShareAction.forceShareRefresh;
    constructor(public forceRefresh: boolean) {}
}
